import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'
/** 单独的logo cssvar基础类 */
export abstract class _LogoLoneBase extends BaseCssVarValue {
  abstract cssType: 'default' | 'larger'
  /** logo宽度 */
  public ['--logo-lone-width']?: string
  /** logo高度 */
  public ['--logo-lone-height']?: string
}
